export default __webpack_public_path__ + "static/media/wppIconWhite.6284369d.svg";